<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>租赁管理</el-breadcrumb-item>
      <el-breadcrumb-item>合同管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.contractName" placeholder="输入合同名称"></el-input>
      </el-form-item>

      <el-form-item v-if="user.username == 'admin'" label="选择部门">
        <el-select v-model="formInline.depId" placeholder="请选择部门" size="small" @change="getData">
          <el-option v-for="item in deptList" :key="item.id" :label="item.departmentName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
     <!-- <el-form-item>
        <el-date-picker type="daterange" size="small" value-format="yyyy-MM-dd" v-model="dayStr" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item> -->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handelAdd">添加</el-button>
      </el-form-item>

    </el-form>

    <el-table :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row
      v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" stripe :max-height="tableHeight">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>

      <el-table-column prop="contractName" label="合同名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="roomName" label="房间名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="contractor" label="签约人" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="contractorPhone" label="签约人手机" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="startContractDate" label="合同开始时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="endContractDate" label="合同结束时间" show-overflow-tooltip>
      </el-table-column>


      <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope">
          <!-- <prems-button size="mini" perms="p:detail" @click="handleEdit(scope.row)" label="编辑" />
          <prems-button size="mini" type="danger" perms="p:delete" @click="deleteInfo(scope.row)" label="删除" /> -->
          <el-button size="mini"  @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteInfo(scope.row)" >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="formInline" @callFather="callFather" v-if="showPage"></Pagination>



    <el-dialog :title="title" :visible.sync="editFormVisible"  @click="editFormVisible = false" :close-on-click-modal="false">
      <el-form label-width="100px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item v-if="user.username == 'admin'" label="选择部门">
          <el-select v-model="editForm.depId" placeholder="请选择部门" size="small" @change="deptChange">
            <el-option v-for="item in deptList" :key="item.id" :label="item.departmentName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="房间" prop="roomId">
              <el-select v-model="editForm.roomId" filterable placeholder="请选择房间" size="small" style="width: 100%;">
                <el-option v-for="item in roomList" :key="item.id" :label="item.roomName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同名称" prop="contractName" >
              <el-input size="small" v-model="editForm.contractName" auto-complete="off" placeholder="请输入合同名称"></el-input>
            </el-form-item>
            <el-form-item label="签约人"  prop="contractor">
              <el-input size="small" v-model="editForm.contractor" auto-complete="off" placeholder="请输入签约人"></el-input>
            </el-form-item>

            <el-form-item label="签约人手机" prop="contractorPhone">
              <el-input size="small" v-model="editForm.contractorPhone" type="number" auto-complete="off" placeholder="请输入签约人手机"></el-input>
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item label="开始日期" prop="startContractDate">
              <el-date-picker v-model="editForm.startContractDate " style="width: 100%;" type="date" size="small"
                value-format="yyyy-MM-dd" placeholder="开始日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期" prop="endContractDate">
              <el-date-picker v-model="editForm.endContractDate" style="width: 100%;" type="date" size="small"
                value-format="yyyy-MM-dd" placeholder="选择结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="经办人">
              <el-input size="small" v-model="editForm.agent" auto-complete="off" placeholder="请输入经办人"></el-input>
            </el-form-item>

            <el-form-item label="经办人手机">
              <el-input size="small" v-model="editForm.agentphone " type="number" auto-complete="off" placeholder="请输入经办人手机"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="租金规则" prop="rents">
          <div class="rents" v-for="item in rents">


             <el-input style="width: 260px; margin-right: 10px;" size="small" v-model="item.rent"  auto-complete="off" placeholder="房租"></el-input>
             <el-input  style="width: 260px;   margin-right: 10px;" size="small" v-model="item.expensesFee"  auto-complete="off" placeholder="管理费"></el-input>
             <el-input  style="width: 260px;   margin-right: 10px;" size="small" v-model="item.elevatorFee"  auto-complete="off" placeholder="电梯费"></el-input>
             <el-input  style="width: 260px;  margin-right: 10px; " size="small" v-model="item.sanitationFee"  auto-complete="off" placeholder="卫生费"></el-input>
             <el-date-picker
               size="small"
               style="width: 500px;position: relative;top: 4px;"
               @change="getDate"
               value-format="yyyy-MM-dd"
               v-model="item.date"
               type="daterange"
               range-separator="至"
               start-placeholder="开始日期"
               end-placeholder="结束日期">
             </el-date-picker>
          </div>
          <el-button type="danger" size="small" icon="el-icon-delete" @click="delRents" v-if="rents.length>1"></el-button>
          <el-button type="primary" :disabled="rents.length >= 10" size="small" icon="el-icon-plus" @click="addRents"></el-button>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="setLoading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>







  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import PremsButton from "@/views/permission/PreButtom";
  import {
    getDepartmentTerminalInfoLis
  } from '../../api/energyMG'
  import {
    saveAndModifyRoomContract,
    findAllRoomList,
    findRoomContractList,
    removeRoomContract,
    toList,
    toListNew,
    getRoomRentList

  } from '../../api/payMG.js'

  export default {
    data() {
      var checkRens = (rule, value, callback) => {

      	if (this.rents[0].rent == '') {
      		return callback(new Error('房租不能为空'));
      	}
        if(this.rents[0].startTime == '' || this.rents[0].endTime == ''){
           return callback(new Error('开始结束时间不能为空'));
         }
         callback();





      };

      return {
        formInline: {
          pageSize: 10,
          currentPage: 1,
          depId: '',
          total: 0,
          contractName: "",
          roomName: '',
          contractor: '',
        },
        saveLoad: false,
        totalFee: "",
        users: [],
        roomList: [],
        editForm: {
          contractName: '',
          contractor: '',
          contractorPhone: '',
          startContractDate: '',
          endContractDate: '',
          agent: '',
          agentphone: "",
          roomId: '',
          depId: '',
          rents:""
        },
        dates:'',
        rents:[
          {
            elevatorFee: "",
            endTime: "",
            expensesFee: "",
            rent: "",
            sanitationFee: "",
            startTime: "",
            date:""
          },
        ],
        pageparm: {

        },
        rtitle: "",
        rechargeFormVisible: false,
        setLoading: false,
        tableHeight: 0,
        title: "",
        loading: false,
        meterPointName: "",
        editFormVisible: false,
        dataList: [],
        deptList: [],
        user: {},
        showPage: true,
        reditForm: {
          totalFee: "",
          appletUserId: '',
          roomId: "",
          mark: "",
          roomType: "63",
          payType: '2',
        },
        dayStr: [],

        money: {
          water: '',
          wuYe: "",
        },

        rules: {
          rent: [{
            required: true,
            message: '请输入租金',
            trigger: 'blur'
          }],

          contractName:[{
            required: true,
            message: '请输入合同名称',
            trigger: 'blur'
          }],

          contractor:[{
            required: true,
            message: '请输入签约人',
            trigger: 'blur'
          }],
          contractorPhone:[{
            required: true,
            message: '请输入签约人手机',
            trigger: 'blur'
          }],

          roomId: [{
            required: true,
            message: '请选择房间',
            trigger: 'change'
          }],
          startContractDate: [{
            required: true,
            message: '开始时间不能为空',
            trigger: 'change'
          }],
          rents:[
            {validator:checkRens,trigger:'blur' }
          ],




          endContractDate: [{
            required: true,
            message: '结束时间不能为空',
            trigger: 'change'
          }],

          // roomNum:[{validator:validatePass,trigger:'change' }]

        },

        ContractList: [],
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 300
      })
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem('userdata'))

      this.editForm.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
      this.formInline.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId

      this.getData()

      if(this.user.username == 'admin'){
        this.getJzData()
      }


      this.getRoomList()

    },
    components: {
      Pagination,
      PremsButton
    },
    methods: {

      addRents(){
        let leng = this.rents.length
        let lastItem = this.rents[leng-1]
        if(lastItem.rent == ''){
          this.$message.warning('房租不能为空')
          return
        }

        if(leng >= 2){

          let sItem = this.rents[leng-2]

          let lastDate =  new Date(sItem.endTime)
          let beginDate = new Date(lastItem.startTime)


          if(lastItem.startTime== '' || lastItem.endTime == ''){
            this.$message.warning('当前开始结束时间不能为空')
            return
          }
          if( beginDate <  lastDate){
            this.$message.warning('当前开始时间不能于小上一条的结束时间')
            return
          }
        }


        this.rents.push({
          elevatorFee: "",
          endTime: "",
          expensesFee: "",
          rent: "",
          sanitationFee: "",
          startTime: "",
          date:""
        })
      },
      delRents(){
        this.rents.pop();
      },


      getDate(e){

        console.log(e)
        this.rents.forEach(item => {
          item.startTime = item.date[0]
          item.endTime = item.date[1]
        })

      },



      deptChange(e) {
        this.editForm.depId = e
        this.getRoomList()
      },

      getRoomList() {
        let param = {
          depId: this.editForm.depId,
          pageSize: 99999,
          currentPage: 1,
          total: 0,
          meterInfoName: "",
          username: "",
          phoneNumber: "",
          roomName: "",
        }

        findAllRoomList(param).then(res => {
          if (res.status == 1) {
            this.roomList = res.data.data
          }
        })
      },
      getJzData: function() {
        return new Promise((resolve, reject) => {
          getDepartmentTerminalInfoLis().then(res => {
            this.treeLoad = false
            if (res.status == 1) {
              let arr = []
              this.deptList = res.data.menuDepList


            } else {
              this.$message.error(res.msg)
            }
          })
        })

      },





      changeType(e) {
        if (this.reditForm.roomType == '63') {
          this.dForm.blance = this.money.water
        } else {
          this.dForm.blance = this.money.wuYe
        }
      },


      getData() {
        this.loading = true
        findRoomContractList(this.formInline).then(res => {
          this.loading = false
          if (res.status == 1) {
            this.dataList = res.data.data
            this.formInline.total = res.data.totalCount

          } else {
            this.$message.error(res.msg)
          }
        })
      },
      handelAdd() {
        this.rents = [{
          elevatorFee: "",
          endTime: "",
          expensesFee: "",
          rent: "",
          sanitationFee: "",
          startTime: "",
          date:"",
        }]
        this.editFormVisible = true
        this.title = '添加'

        this.editForm.id = ""
        this.editForm.contractName = ''
        this.editForm.contractor = ''
        this.editForm.contractorPhone = ''
        this.editForm.startContractDate = ''
        this.editForm.endContractDate = ''
        this.editForm.agent = ''
        this.editForm.agentphone = ''
        this.editForm.roomId = ''
        this.editForm.rents = ''


      },

      handleEdit(row) {
        this.title = '编辑'
        this.rents = []

        this.editFormVisible = true
        this.editForm.id = row.id
        this.editForm.contractName = row.contractName
        this.editForm.contractor = row.contractor
        this.editForm.contractorPhone = row.contractorPhone
        this.editForm.startContractDate = row.startContractDate
        this.editForm.endContractDate = row.endContractDate



        this.editForm.agent = row.agent
        this.editForm.agentphone = row.agentphone
        this.editForm.roomId = row.roomId
        this.editForm.depId = row.departmentId

        this.getRents(row)




        this.getRoomList()


      },

      getRents(row){
        let param = {
          pageSize:999999,
          currentPage:1,
          total:0,
          roomContractId:row.id,
          startTime:'',
          departmentId:"",
          endTime:'',
        }


        getRoomRentList(param).then(res => {
          this.loading = false
          if(res.status == 1){
            this.rents = res.data.data

            this.rents.forEach((item,idx) => {
              // item.date = [item.startTime,item.endTime]
              this.$set(this.rents[idx],'date',[item.startTime,item.endTime])
            })

          }else{
            this.$message.error(res.msg)
          }
        })
      },


      search() {
        this.getData()
      },
      callFather(parm) {
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData()
      },

      deleteInfo(row) {
        this.$confirm('确定要删除吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            // 删除
            removeRoomContract({
                contractId: row.id,

              })
              .then(res => {
                if (res.status == 1) {
                  this.$message({
                    type: 'success',
                    message: '已删除!'
                  })
                  this.getData()
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('删除失败，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除！'
            })
          })
      },
      getMeterInfoList() {
        this.loadMeter = true
        let param = {
          meterPointName: this.meterPointName,
          energyType: 15,
          priceConfigId: this.curPriceId
        }
        findAllMeterInfoList(param).then(res => {
            this.loadMeter = false
            if (res.status == 1) {

              this.MeterInfoList = res.data

              //this.setChoisMeter(row)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loadMeter = false
            this.$message.error('获取数据失败，请稍后再试！')
          })
      },

      submitForm() {

        console.log(this.editForm)

        this.$refs['editForm'].validate(valid => {
          console.log(valid)
          if (valid) {

            if (this.title == '添加') {
              this.add()
            } else {
              this.update()
            }
          }
        })
      },

      add() {

        this.editForm.rents = JSON.stringify(this.rents)
        saveAndModifyRoomContract(this.editForm).then(res => {
          if (res.status == 1) {
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          } else {
            this.$message.error(res.msg)
            this.editForm.rents = []
          }
        })
      },
      update() {
        this.editForm.rents = JSON.stringify(this.rents)

        console.log(this.rents)
        console.log(this.editForm.rents)

        saveAndModifyRoomContract(this.editForm).then(res => {
          if (res.status == 1) {
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    }
  }
</script>

<style>
  .rents{
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/views/property/contract.vue